import React from 'react';
import { createPortal } from 'react-dom';
import { RealizedGainLossDTO } from '../../../../../../../../api/useRealizedGainLossQuery';
import { ActivityCsvExport } from '../../../../../../../../components/ActivityCsvExport/ActivityCsvExport';
import { useExportCsvButtonContainer } from '../../../../../../../../hooks/useExportCsvButtonContainer';
import { TableData } from '../../../../../../../../hooks/useUnrealizedGainLoss';
import { GainLossDetailsWrapper } from '../../../../../GainLossDetailsWrapper/GainLossDetailsWrapper';
import { PositionsDTO } from '../../../../../GainLossMobile/GainLossMobile.meta';

interface Props {
  data: {
    tableData: TableData;
    totals: {
      shortTerm: number;
      longTerm: number;
      total: number;
    };
    gainLoss: RealizedGainLossDTO[];
  };
  debouncedSearchTerm: string;
  title: string;
  setSearchTerm: (value: string) => void;
  searchTerm: string;
  setPositionMobile: (position: PositionsDTO) => void;
}

export const RealizedGainLossDetailsContent = ({
  data,
  debouncedSearchTerm,
  title,
  setSearchTerm,
  searchTerm,
  setPositionMobile,
}: Props) => {
  const exportCsvButtonContainer = useExportCsvButtonContainer();

  return (
    <>
      {!!exportCsvButtonContainer &&
        createPortal(<ActivityCsvExport tab="rgl" />, exportCsvButtonContainer)}

      <GainLossDetailsWrapper
        data={data}
        debouncedSearchTerm={debouncedSearchTerm}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        title={title}
        setPositionMobile={setPositionMobile}
      />
    </>
  );
};
